import { connect } from 'react-redux';
import moment from 'moment';

import API from '@api';
import config from '@config';
import { setUXProp, clearLocation } from '@store/actions/ux';
import { requestFetchTvguide } from '@tvguide/store/actions/requests';
import { setChannels, resetChannels } from '@store/actions/channels';
import { setCookie, eraseCookie } from '@themejs/helpers/cookies';
import RegionSelector from './regionselector';

const mapStateToProps = state => ({
  selectedRegion: state.ux.nid,
  postcode: state.ux.postcode,
});

const locationHost = window.location.host;

if (locationHost.indexOf('freely') > -1) {
  config.defaultNID = config.defaultNIDFreely;
}

const mapDispatchToPros = dispatch => ({
  selectRegion: (nid, postcode) => {
    dispatch(
      setUXProp({
        nid: nid,
        postcode: postcode,
        load: {
          programs: false,
          channels: false,
        },
      }),
    );
    dispatch(resetChannels());

    API.getChannels(nid)
      .then(channels => {
        dispatch(setChannels(channels));
        return;
      })
      .then(() => {
        dispatch(
          requestFetchTvguide(
            nid,
            moment
              .utc()
              .startOf('day')
              .unix(),
          ),
        );
      })
      .catch(error => {
        console.error(error);
      });

    setCookie(config.cookies.nidCookieName, nid);
    setCookie(config.cookies.postcodeCookieName, postcode);
  },
  clearLocation: () => {
    dispatch(clearLocation());
    dispatch(resetChannels());

    API.getChannels(config.defaultNID)
      .then(channels => {
        dispatch(setChannels(channels));
        return;
      })
      .then(() => {
        dispatch(
          requestFetchTvguide(
            config.defaultNID,
            moment
              .utc()
              .startOf('day')
              .unix(),
          ),
        );
      })
      .catch(error => {
        console.error(error);
      });

    eraseCookie(config.cookies.nidCookieName);
    eraseCookie(config.cookies.postcodeCookieName);
  },
});

export default connect(mapStateToProps, mapDispatchToPros)(RegionSelector);
